<template>
    <dialog-generic :visibility.sync = 'visibility' :indicator = 'indicator'>
        <template v-slot:title>{{user.name}} {{user.lastname}}</template>
        <template v-slot:content>
            <v-form class = 'px-4'>
                <v-text-field v-model = 'user.name' label='Имя пользователя' :rules = "[rules.required]"></v-text-field>
                <v-text-field v-model = 'user.lastname' label='Фамилия пользователя' :rules = "[rules.required]"></v-text-field>
                <v-select 
                    v-model = 'user.mode_reports' 
                    :items = '[{"text": "Просмотр доступных", "value": 0},{"text": "Создание, изменение и удаление", "value": 1}]' 
                    item-text = "text" item-value = "value" label = "Содержимое отчета" hint = 'Доступ к отчету' 
                    persistent-hint single-line :rules = "[rules.required]"
                ></v-select>
                <v-select 
                    v-model = 'user.mode_users' 
                    :items = 'modeUsers' item-text = "text" item-value = "value" 
                    label = "Пользователи отчета" hint = 'Доступ к пользователям отчета' persistent-hint 
                    single-line :rules = "[rules.required]"
                ></v-select>
                <v-select 
                    v-model = 'user.mode_projects' 
                    :items = '[{"text": "Просмотр доступных", "value": 0},{"text": "Создание, изменение и удаление", "value": 1}]' 
                    item-text = "text" item-value = "value" label = "Пользователи отчета" hint = 'Доступ к пользователям отчета' 
                    persistent-hint single-line :rules = "[rules.required]"
                ></v-select>
                <v-select 
                    v-if = '$store.getters.grantUsers > 2' 
                    v-model = 'user.domain' 
                    :items = '[{"text": "Artics Internet Solutions", "value": "artics"},{"text": "Daskipper Digital", "value": "daskipper"},{"text": "Не ограничена", "value": "*"}]' 
                    item-text = "text" 
                    item-value = "value" 
                    label = "Область действия" hint = 'Область действия' single-line persistent-hint
                ></v-select>
            </v-form>
        </template>
        <template v-slot:action>
            <v-btn class = 'px-0 light-blue--text text--darken-2' :loading = 'indicator' block depressed @click = 'updatePerson'>Изменить</v-btn>
        </template>
    </dialog-generic>
</template>
<script>
    import DialogGeneric from '@/components/elements/dialogs/Generic.vue'

    export default {
        name: 'UserUpdate',
        props: ['data', 'postAction', 'initialState'],
        components: {'dialog-generic': DialogGeneric},
        data() {
            return {
                modeUsers: [
                    {'text': 'Доступ закрыт', 'value': 0},
                    {'text': 'Просмотр списка', 'value': 1},
                    {'text': 'Создание (в своем домене)', 'value': 2},
                    {'text': 'Создание (для всех доменов)', 'value': 3},
                    {'text': 'Редактирование', 'value': 4},
                    {'text': 'Полный доступ', 'value': 5}
                ],
                visibility: this.initialState,
                user: this.data,
                indicator: false,
                rules: {
                    required: value => !!value || 'Обязательное поле.'
                }
            }
        },
        watch: {
            initialState(value) {
                this.visibility = value
            },
            data(value){
                this.user = value
            },
            visibility(value) {
                this.$emit('update:initialState', value);
            }
        },
        methods: {
            updatePerson() {
                this.indicator = true;
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
                this.$http.put(this.$store.getters.endpoint + '/db/persons', {
                    ...{ 'login': this.$store.getters.userLogin, 'user': this.user }
                }, {
                    headers: { ...this.$store.state.restrictedHeaders,
                        ...requestHeaders
                    }
                }).then((r) => {
                    let response = r.body;
                    if (response.result) {
                        this.indicator = false;
                        this.$dataLayer.$emit('enrich', {
                            event: 'crud',
                            data: {
                                type: 'update',
                                target: 'user'
                            },
                            once: false
                        })
                        this.postAction();
                        this.visibility = false;
                    } else {
                        console.log(response)
                    }
                })
            }
        }
    }
</script>